<template>
    <div class="thumbnail">
        <h2><span class="el-icon-d-arrow-left" @click="back()"></span>Thumbnail Info</h2>
        <div class="searchBox">
            <span class="title">Peer_ID:</span>
            <el-input class="IdInput" v-model="peerId" @keyup.native="peerId=peerId.replace(/\s+/g,'')" placeholder="Input Peer Id" maxlength="16"></el-input>
            <span class="title">Resource_ID:</span>
            <el-input class="IdInput" v-model="resourceId" @keyup.native="resourceId=resourceId.replace(/\s+/g,'')" placeholder="Input Resource Id" maxlength="16"></el-input>
            <el-button class="searchBth" :disabled="isLoading" @click="searchThumbnail">Search</el-button>
        </div>
        <div v-for="(item,i) in showArr" :key="i" class="listInfo" v-if="showArr.length">
            <img :src="item.image" alt="no" class="showImg">
            <p>{{item.peerId}}</p>
            <p>{{item.resourceId}}</p>
            <p>{{item.timestamp}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Thumbnail",
        components:{

        },
        props:{

        },
        data(){
            return{
                peerId:'',
                resourceId:'',
                params:{
                    needDB:'NO',
                    peerId:'',
                    pageNumber:"1",
                    numEveryPage:'15',
                    resourceId:''
                },
                showArr:[],
                isLoading:false,
            }
        },
        methods:{
            back() {
                this.$router.go(-1);
            },
            searchThumbnail(){
                // let arr = [{
                //     date: "1592188787347",
                //     expiration: "1592188787347",
                //     image: "base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wAARCAA4AGQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwCx5EmkRT3OoXDvJaIgnniyzksQBgnBPXvSWuq6XqepwR2D3ov5UbZJKq84U9WByOBUk9teyaPeaTdXELX0qx5lkOVLAgnJI9Kq6R4fvdG1a0v7yeyMMKtuWM/M3ysOPl96AJ3kxcJO8jGYKRvIO4HkdetO3ebPHO8peVUOHblhjOOaiuCZpg2VywJyBx1NSRDaEG9PuN/Dn19q0tH2d+tzGE5Sk09kKW86aCWWVpJFb5Xbkjn1oLfaHgeeVpWV+C4yR09aEPMXzx/e/u//AFqiszLfXJhhmjijhOXm2AnPoAfpWTdjYkmb7SsRuJWlKscF/mx09aLlzcownlaUK/HmZbHXpmpbzT5LWAy2155/l/MYpI1GfXBHeq0M63FsZVdAGYHBXp146UJp7CuTXTmeN0mmaRVkG0PkgdemaZcS+arQyzM6K3yq2SBjPQU+Q8S/PH/rB/D9faq86Ykkbcp+Y9M05NRpTk90tBSburFi6nit9OkmvpZmsYwibEG7BOMYBOKZb6np2rN/Z1g95u8oOIpgNmAAex6/hTr2CTUtGl02CSBJmaORTLwuAACDx16VDo+i3mg6qL+8msjGsO0LGfmJ2gf3emaSd1coV/DmvXZE+n6wba1dRsiE0iheMHgcdcmiibRvE93J5+naosNq4GxBMy44APAHHOaKYEm28jDJqMqNdhB5hIByeO4FKDyvzx/cP8Psfak/07Df2ls+17B5udvXj04pRuyv+r+4fT0NAERP71OV+4eccd6mU8p88f3G/h+vtUJz5qfdzsPpjvUy7sp/q/uN6e9BEKcoXclvqIh5i+eP7393/wCtVLSLw21tcQ5Hml+PlHXJzzV1M5i5j+96Cqk1h57CWN1jkzhyBkY7ZH51E4uS0CcW1oa819buShGxCAxOAed2SOvTHFY2nyrJDdOhRUa4JUFc4B/CopdLvHG1pkX1GD0qzZ2xtbaRA0ZzIG9hwfWppxa3FBSWrLUh4l+eP/WD+H6+1R3B4k+ZT8/YY9fapJN2Jf8AV/6wenvUdxnEmdv3+2PeqqU5VIuEFqzQfnh/mT/Vr1X6e1BP3/nj+4v8P09qOcP9z/Vr1x/s0Hd8/wDq/uD09qpJpWYEU1j4smfzNMvFS0IHlrvAxwM8Y9c0UTJ4yL50p1FngeWP3XoM9eeuaKYEm68kDPqMSLdlB5gJA547A0oHK/JH9w/xex96Lie9TR7zVbu3hW+iWPMcgwu4lQcgn0qno+uXusavZ2N3DZCGZGy0YAYfK3TB9qAJyP3qcL9w8Z471ct7K4nRJIrcOu1hkN3596p3AMMwUhcqCCAcjqamis726RHtpbyOPaRiCZlXPPYHr0qOdc3J1N6qfLF+RONPukMe61Aw3PzdP1qNYJI9u6JVy2G+ftx7/WmLp+ogqHnvzz826dj/AFpq28wCGR5SN3zbpCeOPempKV7PY5pTjH4nYR5tqjzGTOcHMh6fn9age8tUVwXhHzDHz/X3qUoiopkjjOTg7zn/AD3prSWSBt1rYsc4G5FORVLWPMtjSEZTV4K68iGTVbD94PPg5fI+fr196sTkMjsoTBYEFTnPX3qN7vSULg2Wk5DYGYU6c/8A1qJpFZnCIiqWyNnT8PatqT5KsOZbvQOV6+RYx8r/ACp/q16t/u+9BH3/AJI/uD+L6e9JfSyafo0uowxQSSK0carLyvIBOefpVfR9Xu9c1UWN1b2SI0O4NEMMDtBHRumazl8TJJJp/GCPt0qBWswB5ZxGewz1OeuaKJtS8VW8nlabYLJaKB5bCPdngZ5z65oqQJVuH1eKe11G2dXu0QzwRZVwVwRgHJHSi20vSdM1KCSwjvDfxIfLjlI4yp6rjJ4NFFACPHm4SCSJhOVJ2HO4nk9OtBN3DNHbpdXVqzKSIVYAk844IzzRRRH3Zcy3G5NqzJDNewywwz3E4kcgbZDhm5x0xUlzcS7UguIFt2lOBwVbHHIzRRUyhGXT7tPyFO07cyTt5IpvA1rsN2HG8kBZ+B25HT1qDVdMU7XuFltMHau35A35jmiiqXuw5Ft2GpSi7xdvTT8FoTixtdPtcXOnRSYbCzXKnc+cnrwDT7mERK00kBiiZvkJyFOc9CaKKpyk7Xe23kF3q+5JcwQ3GnPBqEcyWEmx/MjOORjGCeKbBpmm6O39paet4W8raskpHl4IA6460UVIiF/EHiO1Ih03SVuLRVHlyCCR93HPIODzmiiigD//2Q==",
                //     peerId: "0xA7CA898B808C0114",
                //     resourceId: "0x0000000000000000",
                //     timestamp: "1592188787347",
                //     type: "Receiver"
                // }]
                // this.showArr = arr
                // this.showArr.map(v => {
                //     v.image = 'data:image/gif;' + v.image;
                //     v.timestamp = this.handlerDate(v.timestamp);
                // })
                if (this.peerId == "" || this.peerId.length != 16){
                    this.$message({
                        message: 'Please check the Peer_ID length being 16 in HEX.',
                        type: 'warning'
                    });
                    return
                }
                if (this.resourceId == "" || this.resourceId.length != 16){
                    this.$message({
                        message: 'Please check the Resource_Id length being 16 in HEX.',
                        type: 'warning'
                    });
                    return
                }
                this.params.peerId = this.peerId.trim();
                this.params.resourceId = this.resourceId.trim();
                this.isLoading = true;
                this.axios.post('/tp/web/ajaxRelayServlet/thumbnailInfo',this.params).then(res => {
                    // console.log(res.data.result.list);
                    this.isLoading = false;
                    this.showArr = res.data.result.list
                    if (res.data.result.list.length == 0) {
                        this.$message({
                            message: 'Not found list',
                        });
                    }
                    this.showArr.map(v => {
                        v.image = 'data:image/gif;' + v.image;
                        v.timestamp = this.handlerDate(v.timestamp);
                    })
                }).catch(err => {
                    this.isLoading = false;
                    console.log(err)
                })
            },
            handlerDate(date) {
                if (date == "") {
                    return;
                } else {
                    let str = new Date(Number(date)).toUTCString()
                    return str;
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .thumbnail{
        width: 775px;
        max-width: 1024px;
        border: 0 solid gray;
        margin-top: -22px;
        margin-left: auto;
        margin-right: auto;
        background-color: #151515;
        color: white;
        h2 {
            span {
                padding-right: 15px;
                cursor: pointer;
            }
            color: #fff;
            font-size: 24px;
        }
        .searchBox{
            padding:10px 30px;
            height: 30px;
            .title {
                float: left;
                color: #ffffff;
                line-height: 30px;
                padding: 0 10px;
            }

            .IdInput {
                width: 173px;
                float: left;

                /deep/ .el-input__inner {
                    height: 30px;
                }
            }
            .searchBth {
                height: 30px;
                line-height: 5px;
                float: left;
                margin-left: 10px;
            }
        }
        .listInfo{
            width: 50%;
            height: 80px;
            margin: 0 auto;
            img{
                float: left;
            }
            p{
                margin: 2px 0;
            }
        }
    }

</style>